import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['phoneNumber', 'button', 'countryCode'];
  connect() {
    this.buttonTarget.setAttribute('disabled', true);
    this.validateForm();
  }

  validateForm() {
    let status = false;
    if (this.validatePhoneNumber()) {
      status = true;
      this.buttonTarget.removeAttribute('disabled');
    } else {
      this.buttonTarget.setAttribute('disabled', true);
    }
    return status;
  }

  validatePhoneNumber() {
    const value = this.phoneNumberTarget.value;
    if (this.hasCountryCodeTarget) {
      return this.countryCodeTarget.value && value && value.length >= 10;
    }

    return value && value.length >= 10;
  }
}
